import React from "react";

import { Plus } from "lucide-react";
import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import { useDossier, DOSSIER_ACTIONS, useDossierDispatch } from "@app/contexts/DossierContext";
import { useCustomerDispatch, CUSTOMER_ACTIONS } from "@app/contexts/CustomerContext";
import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";

export default function ButtonNewDossier({reload}) {
    const auth = useAuth();
    const dossier = useDossier();
    
    const customerDispatch = useCustomerDispatch();
    const dossierDispatch = useDossierDispatch();

    function createNewDossier(event) {
        event.preventDefault();

        apiCall({
            method: "post",
            path: `/api/v1/dossiers/duplicate/${dossier.id}`,
            auth: auth,
            onSuccess: (response) => {
                const dossierUp = response.data.dossier;
                
                customerDispatch({
                    type: CUSTOMER_ACTIONS.ADD_DOSSIER,
                    payload: {dossier: dossierUp }
                });

                dossierDispatch({
                    type: DOSSIER_ACTIONS.UPDATE_ALL,   
                    payload: dossierUp
                });

                reload(dossierUp.id)
            }
        });
    }

    return (
        <ButtonSecondary 
            label="Nouveau bilan"
            icon={<Plus />}
            onClick={createNewDossier}
        />
    )
}